<template>
  <div>
    <!-- <Header /> -->
    <div
      v-if="userInfo && userInfo.user"
      class="sticky top-0 z-50 bg-white shadow-md"
    >
      <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <CoordinateHeader
        v-if="this.userInfo.user.permission == 'co-ordinator'"
      />
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
    </div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="pb-10 pt-4 max-h-screen overflow-y-auto">
      <div class="container mx-auto max-w-[1200px] flex flex-col gap-4 px-6">
        <div class="flex justify-between items-center">
          <h1 class="text-xl md:text-xl text-start font-bold text-black">
            Blogs <span v-if="blogcount">({{ blogcount || 0 }}) </span>
          </h1>
          <router-link
            :to="{ name: 'InstructorBlogsView' }"
            class="ml-auto bg-blues hover:bg-[#18469d] hover:text-white text-white rounded-xl text-xs font-semibold px-4 py-1.5"
          >
            Add Blog
          </router-link>
        </div>
        <!-- Loading -->
        <div
          v-if="loading"
          class="flex items-center justify-center min-h-[300px] md:min-h-[400px]"
        >
          <img src="@/assets/newd/loading.gif" alt="Loading..." />
        </div>

        <!-- Blog List -->
        <div v-else-if="bloglist.length > 0">
          <div
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10"
          >
            <div
              class="rounded-3xl bg-white shadow-lg relative group hover:shadow-xl transition-shadow duration-300"
              v-for="blog in bloglist"
              :key="blog.id"
            >
              <!-- Action Buttons Container -->
              <div class="absolute top-7 right-7 z-10 flex gap-2">
                <!-- Edit Button -->
                <router-link
                  :to="{
                    name: 'InstructorBlogsEdit',
                    params: { blog_id: blog.id },
                  }"
                  class="edit-btn"
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-8 h-8 bg-[#EDF8FF] hover:bg-green-100 rounded-lg p-1.5 transition-colors duration-200"
                  >
                    <path
                      d="M16.862 3.487a2.25 2.25 0 013.182 3.182L8.5 18.213l-3.5.787.786-3.5L16.862 3.487z"
                      stroke="#10B981"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      fill="none"
                    />
                    <path
                      d="M15 5l4 4"
                      stroke="#10B981"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </router-link>

                <!-- Delete Button -->
                <button
                  class="delete-btn"
                  @click.stop="
                    titlepass = blog.title;
                    popupwindow = true;
                    idpass = blog.id;
                  "
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-8 h-8 bg-red-50 hover:bg-red-100 rounded-lg p-1.5 transition-colors duration-200"
                  >
                    <path
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      stroke="#EF4444"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      fill="none"
                    />
                  </svg>
                </button>
              </div>

              <router-link
                :to="{
                  name: 'InstructorBlogDetails',
                  params: { blog_id: blog.id },
                }"
              >
                <div
                  class="flex flex-col min-h-[380px] md:min-h-[320px] justify-between gap-3 p-4"
                >
                  <!-- Thumbnail -->
                  <div class="relative overflow-hidden rounded-lg">
                    <img
                      v-if="blog.thumbnail"
                      class="object-cover object-center h-[200px] md:h-[250px] w-full rounded-lg transition-transform duration-300 group-hover:scale-105"
                      :src="blog.thumbnail"
                      alt="Blog Thumbnail"
                    />
                    <img
                      v-else
                      class="object-cover object-center h-[200px] md:h-[250px] w-full rounded-lg"
                      src="@/assets/coding.svg"
                      alt="Default Image"
                    />
                  </div>

                  <!-- Blog Details -->
                  <div class="space-y-1">
                    <h1 class="font-bold text-lg text-primary">
                      {{ blog.title }}
                    </h1>

                    <div class="flex items-center justify-between">
                      <p class="text-blues text-sm font-bold">
                        {{ blog.bolger_id.display_name }}
                      </p>
                      <div class="text-sm text-gray-500 font-medium">
                        {{ formatDate(blog.updated_date) }}
                      </div>
                    </div>

                    <p
                      class="text-gray-600 line-clamp-3 text-sm"
                      v-html="blog.content"
                    ></p>
                  </div>
                </div>
              </router-link>
            </div>
          </div>

          <!-- Pagination Controls -->
          <div
            v-if="bloglist.length > 1"
            class="flex items-center justify-center w-full pb-8 mt-6"
          >
            <Pagination :totalPages="totalPages" @page-changed="fetchBlogs" />
          </div>
        </div>

        <!-- No Data -->
        <div v-else class="text-lg font-normal text-center py-12">
          No data found
        </div>

        <!-- Delete Popup -->
        <div
          v-if="popupwindow"
          class="fixed flex bg-black bg-opacity-70 justify-center items-center inset-0 z-50 outline-none overflow-x-hidden overflow-y-auto"
          style="z-index: 5000"
        >
          <div class="w-[90%] lg:w-[35%] rounded-md m-4 animate-fadeIn">
            <div
              class="relative flex flex-col clear-both justify-center rounded-t-lg w-full pt-12 p-4 md:p-10 bg-white gap-3"
            >
              <button
                @click="popupwindow = false"
                class="absolute right-2 top-2 cursor-pointer hover:bg-gray-100 rounded-full p-1"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 18L18 6M6 6l12 12"
                    stroke="#666"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <div class="text-center">
                <p class="text-center font-base text-xl text-gray-600 mb-2">
                  Are you sure want to delete?
                </p>
                <h1 class="text-center font-bold text-xl text-blues">
                  "{{ titlepass }}"
                </h1>
              </div>
            </div>

            <div
              class="body-popup flex flex-col rounded-b-lg py-3 md:py-6 px-3 md:px-6 bg-gray-100"
            >
              <div class="flex gap-4 justify-between w-full md:w-3/4 mx-auto">
                <button
                  @click="popupwindow = false"
                  class="bg-white hover:bg-gray-200 text-gray-700 text-sm font-semibold rounded-lg overflow-hidden px-6 py-2 transition-colors duration-200 border border-gray-300"
                >
                  Cancel
                </button>

                <div class="relative flex items-center">
                  <button
                    @click="deleteblog()"
                    :disabled="disable_submit == true"
                    :class="
                      disable_submit == true
                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        : 'bg-blues hover:bg-blue-600 cursor-pointer text-white'
                    "
                    class="text-sm font-semibold rounded-lg overflow-hidden px-6 py-2 transition-colors duration-200"
                  >
                    Delete
                  </button>

                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="absolute -right-8 w-6 h-6 object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InstructorHeader from "@/components/Instructor/Header.vue";
import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import FlashMessage from "@/components/FlashMessage.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    InstructorHeader,
    AdminHeader,
    HodHeader,
    CoordinateHeader,
    FlashMessage,
    Pagination,
  },

  data() {
    return {
      bloglist: [],

      loading: true,
      popupwindow: false,
      titlepass: null,
      idpass: null,
      messages: {
        text: "",
        type: "null",
      },
      blogcount: null,
      totalPages: null,
      currentPage: 1,
      disable_submit: false,
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  created() {
    this.fetchBlogs(1);
  },

  methods: {
    fetchBlogs(value) {
      this.currentPage = value;
      axios
        .get(
          `${process.env.VUE_APP_API}/blog-details/list/?page=${value}&Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.bloglist = res.data.data.data;
            this.blogcount = res.data.total;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
            this.totalPages = res.data.total_page;
          }
        })
        .catch((error) => {
          console.error("Error fetching blogs:", error);
        });
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    async deleteblog() {
      this.disable_submit = true;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/blog-details/deleted/${this.idpass}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            console.log("successful");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            console.log("not successful");
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.disable_submit = false;
        this.popupwindow = false;
        this.fetchBlogs(1);
      }, 2500);
    },
  },
};
</script>

<style></style>
